import { render, staticRenderFns } from "./menuCard.vue?vue&type=template&id=08bdedbb&scoped=true"
import script from "./menuCard.vue?vue&type=script&lang=js"
export * from "./menuCard.vue?vue&type=script&lang=js"
import style0 from "./menuCard.vue?vue&type=style&index=0&id=08bdedbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bdedbb",
  null
  
)

export default component.exports